import { BalanceTypes } from "@redotech/redo-model/balance/balances";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const getBalance = {
  name: "getBalance" as const,
  input: z.object({ account: createEnum(BalanceTypes), teamId: z.string() }),
  output: z.object({ balance: z.string().nullish() }),
};
